"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UIAutosizedTextInput = _interopRequireDefault(require("UIComponents/input/UIAutosizedTextInput"));

var FilenameInput =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FilenameInput, _Component);

  function FilenameInput() {
    (0, _classCallCheck2.default)(this, FilenameInput);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FilenameInput).apply(this, arguments));
  }

  (0, _createClass2.default)(FilenameInput, [{
    key: "blur",
    value: function blur() {
      if (this.input && this.input.getSelectableNode) {
        var node = this.input.getSelectableNode();
        node.blur();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          onChange = _this$props.onChange,
          error = _this$props.error,
          value = _this$props.value,
          onBlur = _this$props.onBlur,
          onKeyDown = _this$props.onKeyDown;
      return _react.default.createElement("span", {
        className: "is--heading-7 m-left-2 m-bottom-4 m-right-8"
      }, _react.default.createElement(_UIAutosizedTextInput.default, {
        ref: function ref(c) {
          _this.input = c;
        },
        affordance: true,
        onChange: onChange,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        value: value,
        error: error
      }));
    }
  }]);
  return FilenameInput;
}(_react.Component);

exports.default = FilenameInput;
FilenameInput.propTypes = {
  error: _react.PropTypes.bool,
  onChange: _react.PropTypes.func.isRequired,
  onBlur: _react.PropTypes.func.isRequired,
  onKeyDown: _react.PropTypes.func.isRequired,
  value: _react.PropTypes.string.isRequired
};
module.exports = exports.default;